import { UseFormSetError, FieldValues, Path } from "react-hook-form";

export const useServerErrors = <T extends FieldValues>(setError: UseFormSetError<T>) => {
    const handleServerErrors = (errors: Record<string, string[]>, fieldMap: Record<string, Path<T>> = {}) => {
        Object.entries(errors).forEach(([key, messages]) => {
            // Use the mapped field name if provided, otherwise use the key from the server
            const fieldName = (fieldMap[key] || key) as Path<T>;
            setError(fieldName, {
                type: "server",
                message: messages[0],
            });
        });
    };

    return { handleServerErrors };
};